import {useInfiniteQuery} from "@tanstack/react-query";
import {HistoryListElementType, HistoryListMapType, HistorySearchParamType} from "../interface";
import {readInventoryHistory} from "../../../../api/inventory/HistoryApi";
import {historyListMapInit} from "../state";
import {useEffect, useState} from "react";

type Props = {
    param: HistorySearchParamType;
};

export const useReadInventoryHistory = ({param}: Props) => {
    const [dataList, setDataList] = useState<HistoryListElementType[]>([])

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        status,
    } = useInfiniteQuery<HistoryListMapType>({
        queryKey: ['readInventoryHistory', param],
        queryFn: async ({pageParam}) => {
            const res = await readInventoryHistory({...param, pageNo: pageParam as number})

            return res.data.result ?? historyListMapInit
        },
        getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
            const totalPages = Math.ceil(lastPage.totalCount / param.limit);
            const pageNo = lastPageParam as number

            return pageNo < totalPages ? pageNo + 1 : undefined;
        },
        initialPageParam: 1
    });

    useEffect(() => {
        if (data?.pages) {
            setDataList(data.pages.flatMap(el => el.inventoryHistoryResList))
        }
    }, [data]);

    return {data, dataList, fetchNextPage, hasNextPage, isFetchingNextPage, status};
};